<template>
    <v-container fluid class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t("customerList.header") }}
        </div>

        <v-card>
            <v-card-text class="pb-1">
                <v-row>
                    <v-col cols="5">
                        <v-text-field
                            outlined
                            v-model="search"
                            append-icon="search"
                            height="40px"
                            :placeholder="
                                $t('placeholder.filterByEmailAndName')
                            "
                        />
                    </v-col>

                    <v-col cols="2">
                        <v-select
                            outlined
                            v-model="filter.nationality"
                            append-icon="expand_more"
                            height="40px"
                            :menu-props="{
                                offsetY: true,
                            }"
                            :items="nationalityList"
                            @change="fetchCustomers"
                        />
                    </v-col>

                    <v-col cols="2">
                        <v-select
                            outlined
                            hide-details
                            v-model="filter.status"
                            append-icon="expand_more"
                            height="40px"
                            :menu-props="{
                                offsetY: true,
                            }"
                            :items="statusList"
                            @change="fetchCustomers"
                        />
                    </v-col>

                    <v-col cols="3">
                        <v-btn
                            class="font-weight-regular"
                            color="primary"
                            @click="getExportExcel">
                            <icon
                                class="mr-2"
                                value="file_download"
                                size="18px"/>
                            {{ $t('button.exportXlsx') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <customer-list-view
                class="customerListView"
                :search="search"
                :customers="customers"
                :pagination="pagination"
                @fetch="fetchCustomers"
            />
        </v-card>

        <v-pagination
            v-show="showPagination"
            class="pt-2"
            :style="{
                marginRight: '-8px',
            }"
            :value="page"
            :length="pageTotal"
            :total-visible="totalVisible"
            @input="onPaginationChanged"
        />
    </v-container>
</template>

<script>
import CustomerListView from '@/views/CustomerListView'
import PaginationMixin from '@/mixins/PaginationMixin'

import { mapState } from 'vuex'

export default {
    name: 'CustomerListPage',

    mixins: [PaginationMixin],

    components: {
        CustomerListView
    },

    data () {
        return {
            filter: {
                nationality: this.$t('customerList.allNationality'),
                status: this.$constant.ACTIVE_STATUS
            },

            statusList: [
                this.$constant.ACTIVE_STATUS,
                this.$constant.INACTIVE_STATUS,
                this.$constant.ALL_STATUS
            ],
            search: ''
        }
    },

    computed: {
        nationalityList () {
            return [
                this.$t('customerList.allNationality'),
                ...this.nationalities
            ]
        },

        ...mapState(['nationalities']),
        ...mapState('customer', ['customers', 'total'])
    },

    mounted () {
        this.fetchCustomers()
    },

    methods: {
        fetchCustomers () {
            this.$store.dispatch(
                'customer/fetchCustomers',
                this.getQueryObject()
            )
        },

        getQueryObject () {
            return {
                page: this.page,
                itemsPerPage: this.itemsPerPage,
                sortBy: this.sortBy,
                sortType: this.sortType,
                status:
                    this.filter.status !== this.$constant.ALL_STATUS
                        ? this.filter.status
                        : undefined,
                nationality:
                    this.filter.nationality !==
                    this.$t('customerList.allNationality')
                        ? this.filter.nationality
                        : undefined
            }
        },

        onPaginationChanged (value) {
            this.page = value
            this.fetchCustomers()
        },
        getExportExcel () {
            const url = process.env.VUE_APP_BASE_URL + '/export/customer-list?page=1&itemsPerPage=50'
            // FileSaver.saveAs(blob, filename)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'filename')
            document.body.appendChild(link)
            link.click()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
